exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!../../../assets/css/Error.min.css"), "");

// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"Error404.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e045694","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Pages/Error/Error404.vue
// module id = 682
// module chunks = 3